import React from 'react'
import styled from 'styled-components'
import { BaseButton } from '../Section'

const WhiteLineBtn = styled(BaseButton)`		
	background-color:transparent;
	color:#fff;	
	& .icon{
		> svg{
			fill:#fff;
		}
	}
	&:hover{		
		color:#E9242A;
		& .icon{
			> svg{
				fill:#E9242A;
			}
		}
	}
`
const WhiteLineButton = (props) => {
	const { icon, iconAfter, text, size } = props;
	return(
		<WhiteLineBtn className={`btn ${size ? `btn-${size}` : ''} `}>
			{ iconAfter ? (
				<>
					{ text && <span className='text'>{text}</span>}
					{ iconAfter && <span className='icon'>{iconAfter}</span>}
				</>
				):(
					<>
						{ icon && <span className='icon'>{icon}</span>}
						{ text && <span className='text'>{text}</span>}
					</>
				)
			}
		</WhiteLineBtn>
	)
}


export default WhiteLineButton

